import React from 'react'

import { InputMultiSelectDropdownList } from '../dropdown-list'

export function useSplitChildren(children: React.ReactNode) {
  const childrenArray = React.Children.toArray(children)

  const dropdownElement = childrenArray.find(
    child =>
      React.isValidElement(child) && child.type === InputMultiSelectDropdownList
  )

  return {
    clonedDropdownElement:
      dropdownElement &&
      React.cloneElement(dropdownElement as React.ReactElement),
    otherElements: childrenArray.filter(
      child =>
        React.isValidElement(child) &&
        child.type !== InputMultiSelectDropdownList
    ),
  }
}
